import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { MaterialModule } from "../../core/shared/material.module";
import { SharedComponents } from "../shared.module";

@Component({
  selector: "app-script-card-tile",
  standalone: true,
  imports: [CommonModule, MaterialModule, ...SharedComponents],
  templateUrl: "./script-card-tile.component.html",
  styleUrl: "./script-card-tile.component.scss",
})
export class ScriptCardTileComponent implements OnChanges {
  @Input() cardList!: any;
  @Input() loading = false;
 
  @Output() onActionFireEvents = new EventEmitter<{
    event: ScriptCardTileComponent;
    actionType?: string;
    $event?: Event;
  }>();
  @Output() selectedCardsChange = new EventEmitter<any[]>();
  @Output() onEditClick = new EventEmitter<{
    event: ScriptCardTileComponent;
    actionType?: string;
    $event?: Event;
  }>();

  contextMenuIndex: number | null = null; // Index of the card where the menu is open
  contextMenuPosition = { x: 0, y: 0 }; //

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
  }

  onActionFire(card: any): void {
    this.cardList.forEach((c: any) => (c.isClicked = false));
    card.isClicked = true;
    this.onActionFireEvents.emit({
      event: this,
      actionType: card?.type,
      $event: card,
    });
  }

  toggleContextMenu(event: Event, index: number): void {
    event.stopPropagation();
    this.contextMenuIndex = this.contextMenuIndex === index ? null : index;
    if (event instanceof MouseEvent) {
      this.contextMenuPosition = { x: event.clientX, y: event.clientY }; // Set menu position
    }
  }

  handleContextMenuAction(event: Event, action: string, card: any): void {
    this.contextMenuIndex = null;
    this.onActionFireEvents.emit({
      event: this,
      actionType: action,
      $event: card,
    });
    event.stopPropagation();
  }

  selectedCards: any[] = [];

  onCheckboxClick(event: Event, card: any) {
    event.stopPropagation(); // Prevent card click event from firing
    const index = this.selectedCards.findIndex((c) => c.id === card.id);
    
    if (index === -1) {
      this.selectedCards.push(card);
    } else {
      this.selectedCards.splice(index, 1);
    }
  
    this.selectedCardsChange.emit(this.selectedCards); // Emit updated selectedCards list
  }

  isSelected(card: any): boolean {
    return this.selectedCards.some((c) => c.id === card.id);
  }

  onEdit(event: Event, card: any){
    this.onEditClick.emit({
      event: this,
      actionType: "edit",
      $event: card,
    });
    event.stopPropagation();
  }

}
